import React, { Component } from 'react';
import PropTypes from 'prop-types';

function getSafe(fn, defaultValue) {
    try {
        return fn();
        // eslint-disable-next-line no-unused-vars
    } catch (e) {
        return defaultValue;
    }
}


class Alert extends Component {
    componentDidMount() {
        const { unMountAlert } = this.props;
        setTimeout(() => unMountAlert(), 7000);
    }
    render() {
        const { heading, type, message, id, isList, fade = true, children } = this.props;
        const headingWithCount = getSafe(() => children.props.errors)
            ? `${heading} - ${Object.keys(children.props.errors).length} ${
                  Object.keys(children.props.errors).length === 1 ? 'error' : 'errors'
              } on this page.`
            : heading;

        let fadeClass = '';
        let typeClass = '';

        switch (type) {
            case 'success':
                fadeClass = fade ? 'fade' : '';
                typeClass = 'usa-alert--success';
                break;

            case 'warning':
                fadeClass = fade ? 'fade' : '';
                typeClass = 'usa-alert--warning';
                break;

            case 'error':
                typeClass = 'usa-alert--error margin-bottom';
                break;

            case 'info':
                typeClass = 'usa-alert--info';
                break;
        }

        let messageCopy;

        if (Array.isArray(message)) {
            if (isList) {
                messageCopy = message.map((error, index) => <p key={index}>{error}</p>);
            } else {
                messageCopy = message.map((error, index) => <div key={index}>{error}</div>);
            }
        } else {
            messageCopy = message;
        }

        return (
            <div className={fadeClass}>
                <div
                    aria-atomic="false"
                    aria-live="polite"
                    className={`usa-alert ${typeClass}`}
                    id={id}
                    role="alert"
                    tabIndex="0"
                >
                    <div className="usa-alert__body">
                        <div className="usa-alert__heading h3">{headingWithCount}</div>
                        {messageCopy && <div className="usa-alert__text">{messageCopy}</div>}
                        {children && <div className="usa-alert__text"> {children} </div>}
                    </div>
                </div>
            </div>
        );
    }
}

Alert.defaultProps = {
    heading: 'Error',
    type: 'error',
    unMountAlert: () => {}
};
export const alertPropTypes = {
    heading: PropTypes.string,
    id: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
    type: PropTypes.string,
    fade: PropTypes.bool,
    unMountAlert: PropTypes.func,
    isList: PropTypes.bool,
    errors: PropTypes.object
};
Alert.propTypes = alertPropTypes;

export default Alert;




// WEBPACK FOOTER //
// ./src/common/Alert.js